const initialState = {
  inputRepairs: [],
  dataSealNo: [],
};

const vaultingMovementReducers = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_INPUT_REPAIR':
      return {
        ...state,
        inputRepairs: action.payload,
      };
    case 'RESET_INPUT_REPAIR':
      return {
        ...state,
        inputRepairs: action.payload,
      };
    case 'SET_DATA_SEAL_NO':
      return {
        ...state,
        dataSealNo: action.payload,
      };
    case 'RESET_DATA_SEAL_NO':
      return {
        ...state,
        dataSealNo: action.payload,
      };
    default:
      return state;
  }
};

export default vaultingMovementReducers;
